import { alias, primitive, serializable } from 'serializr';

export class CommodityMetaData {
  @serializable(alias('current_page', primitive()))
  currentPage?: number;

  @serializable(alias('total_pages', primitive()))
  totalPages?: number;

  @serializable(alias('total_items', primitive()))
  totalItems?: number;

  @serializable(alias('page_size', primitive()))
  pageSize?: number;
}
